const costMenu: any = {
  id: "cost-allocation",
  parent_id: "commissions",
  title: "Costi",
  translate: "COSTS",
  type: "collapsible",
  icon: "user",
  capability: "show_menu_cost",
  children: [
    {
      id: "providers-cost-list",
      title: "Fornitori",
      translate: "MENU.PROVIDERS_COST",
      type: "item",
      capability: "show_menu_providers_cost",
      url: "dashboard/costs/providers-cost-list",
    },
    {
      id: "structure-cost-list",
      title: "Struttura",
      translate: "MENU.STRUCUTURE_COST",
      type: "item",
      capability: "show_menu_structure_cost",
      url: "dashboard/costs/structure-cost-list",
    },
  ],
  order: 1,
};
export default costMenu;
